var map = {
	"./comics-1/desktop/frame-1/bg.png": 83998,
	"./comics-1/desktop/frame-10/bg.png": 71255,
	"./comics-1/desktop/frame-11/bg.png": 83332,
	"./comics-1/desktop/frame-12/bg.png": 70218,
	"./comics-1/desktop/frame-13/bg.png": 98819,
	"./comics-1/desktop/frame-14/bg.png": 80794,
	"./comics-1/desktop/frame-2/bg.png": 33849,
	"./comics-1/desktop/frame-3/bg.png": 89120,
	"./comics-1/desktop/frame-4/bg.png": 20783,
	"./comics-1/desktop/frame-5/bg.png": 22986,
	"./comics-1/desktop/frame-6/bg.png": 47391,
	"./comics-1/desktop/frame-7/bg.png": 22331,
	"./comics-1/desktop/frame-8/bg.png": 37210,
	"./comics-1/desktop/frame-9/bg.png": 41009,
	"./comics-1/mobile/frame-1/bg.png": 80332,
	"./comics-1/mobile/frame-10/bg.png": 48418,
	"./comics-1/mobile/frame-11/bg.png": 37989,
	"./comics-1/mobile/frame-12/bg.png": 63264,
	"./comics-1/mobile/frame-13/bg.png": 11415,
	"./comics-1/mobile/frame-14/bg.png": 10719,
	"./comics-1/mobile/frame-2/bg.png": 190,
	"./comics-1/mobile/frame-3/bg.png": 67241,
	"./comics-1/mobile/frame-4/bg.png": 74983,
	"./comics-1/mobile/frame-5/bg.png": 90146,
	"./comics-1/mobile/frame-6/bg.png": 4186,
	"./comics-1/mobile/frame-7/bg.png": 40683,
	"./comics-1/mobile/frame-8/bg.png": 37833,
	"./comics-1/mobile/frame-9/bg.png": 5915,
	"./comics-10/desktop/frame-1/bg.png": 64811,
	"./comics-10/desktop/frame-2/bg.png": 78745,
	"./comics-10/mobile/frame-1/bg.png": 45976,
	"./comics-10/mobile/frame-2/bg.png": 64823,
	"./comics-11/desktop/frame-1/bg.png": 40127,
	"./comics-11/desktop/frame-2/bg.png": 4444,
	"./comics-11/desktop/frame-3/bg.png": 54230,
	"./comics-11/desktop/frame-4/bg.png": 24398,
	"./comics-11/mobile/frame-1/bg.png": 72368,
	"./comics-11/mobile/frame-2/bg.png": 98857,
	"./comics-11/mobile/frame-3/bg.png": 23444,
	"./comics-11/mobile/frame-4/bg.png": 27892,
	"./comics-12/desktop/frame-1/bg.png": 22639,
	"./comics-12/desktop/frame-2/bg.png": 3942,
	"./comics-12/desktop/frame-3/bg.png": 81249,
	"./comics-12/desktop/frame-4/bg.png": 40968,
	"./comics-12/desktop/frame-5/bg.png": 25148,
	"./comics-12/mobile/frame-1/bg.png": 23929,
	"./comics-12/mobile/frame-2/bg.png": 83619,
	"./comics-12/mobile/frame-3/bg.png": 64155,
	"./comics-12/mobile/frame-4/bg.png": 75058,
	"./comics-12/mobile/frame-5/bg.png": 72477,
	"./comics-2/desktop/frame-1/bg.png": 67084,
	"./comics-2/desktop/frame-2/bg.png": 69025,
	"./comics-2/mobile/frame-1/bg.png": 71561,
	"./comics-2/mobile/frame-2/bg.png": 90371,
	"./comics-3/desktop/frame-1/bg.png": 9997,
	"./comics-3/desktop/frame-2/bg.png": 90068,
	"./comics-3/desktop/frame-3/bg.png": 41513,
	"./comics-3/desktop/frame-4/bg.png": 23342,
	"./comics-3/mobile/frame-1/bg.png": 29760,
	"./comics-3/mobile/frame-2/bg.png": 86128,
	"./comics-3/mobile/frame-3/bg.png": 89881,
	"./comics-3/mobile/frame-4/bg.png": 43962,
	"./comics-4/desktop/frame-1/bg.png": 20430,
	"./comics-4/desktop/frame-2/bg.png": 35420,
	"./comics-4/desktop/frame-3/bg.png": 21052,
	"./comics-4/desktop/frame-4/bg.png": 17459,
	"./comics-4/desktop/frame-5/bg.png": 25846,
	"./comics-4/mobile/frame-1/bg.png": 26015,
	"./comics-4/mobile/frame-2/bg.png": 56822,
	"./comics-4/mobile/frame-3/bg.png": 60866,
	"./comics-4/mobile/frame-4/bg.png": 77658,
	"./comics-4/mobile/frame-5/bg.png": 49073,
	"./comics-5/desktop/frame-1/bg.png": 253,
	"./comics-5/desktop/frame-2/bg.png": 93046,
	"./comics-5/desktop/frame-3/bg.png": 46988,
	"./comics-5/desktop/frame-4/bg.png": 79443,
	"./comics-5/desktop/frame-5/bg.png": 80255,
	"./comics-5/desktop/frame-6/bg.png": 58434,
	"./comics-5/desktop/frame-7/bg.png": 49517,
	"./comics-5/desktop/frame-8/bg.png": 93,
	"./comics-5/mobile/frame-1/bg.png": 49424,
	"./comics-5/mobile/frame-2/bg.png": 13398,
	"./comics-5/mobile/frame-3/bg.png": 70929,
	"./comics-5/mobile/frame-4/bg.png": 47414,
	"./comics-5/mobile/frame-5/bg.png": 38348,
	"./comics-5/mobile/frame-6/bg.png": 17140,
	"./comics-5/mobile/frame-7/bg.png": 32836,
	"./comics-5/mobile/frame-8/bg.png": 38115,
	"./comics-6/desktop/frame-1/bg.png": 5651,
	"./comics-6/desktop/frame-2/bg.png": 9314,
	"./comics-6/mobile/frame-1/bg.png": 12752,
	"./comics-6/mobile/frame-2/bg.png": 1596,
	"./comics-7/desktop/frame-1/bg.png": 41773,
	"./comics-7/desktop/frame-2/bg.png": 75143,
	"./comics-7/desktop/frame-3/bg.png": 4285,
	"./comics-7/desktop/frame-4/bg.png": 82221,
	"./comics-7/mobile/frame-1/bg.png": 68654,
	"./comics-7/mobile/frame-2/bg.png": 95023,
	"./comics-7/mobile/frame-3/bg.png": 46728,
	"./comics-7/mobile/frame-4/bg.png": 21460,
	"./comics-8/desktop/frame-1/bg.png": 21098,
	"./comics-8/desktop/frame-2/bg.png": 56992,
	"./comics-8/desktop/frame-3/bg.png": 38129,
	"./comics-8/desktop/frame-4/bg.png": 55277,
	"./comics-8/desktop/frame-5/bg.png": 5408,
	"./comics-8/mobile/frame-1/bg.png": 10004,
	"./comics-8/mobile/frame-2/bg.png": 57590,
	"./comics-8/mobile/frame-3/bg.png": 85598,
	"./comics-8/mobile/frame-4/bg.png": 97239,
	"./comics-8/mobile/frame-5/bg.png": 81501,
	"./comics-9/desktop/frame-1/bg.png": 55729,
	"./comics-9/desktop/frame-2/bg.png": 47695,
	"./comics-9/desktop/frame-3/bg.png": 59674,
	"./comics-9/desktop/frame-4/bg.png": 6352,
	"./comics-9/desktop/frame-5/bg.png": 49044,
	"./comics-9/desktop/frame-6/bg.png": 25785,
	"./comics-9/desktop/frame-7/bg.png": 61776,
	"./comics-9/desktop/frame-8/bg.png": 62789,
	"./comics-9/desktop/frame-9/bg.png": 73566,
	"./comics-9/mobile/frame-1/bg.png": 90559,
	"./comics-9/mobile/frame-2/bg.png": 23765,
	"./comics-9/mobile/frame-3/bg.png": 2856,
	"./comics-9/mobile/frame-4/bg.png": 14440,
	"./comics-9/mobile/frame-5/bg.png": 40652,
	"./comics-9/mobile/frame-6/bg.png": 33147,
	"./comics-9/mobile/frame-7/bg.png": 63820,
	"./comics-9/mobile/frame-8/bg.png": 1174,
	"./comics-9/mobile/frame-9/bg.png": 3116
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 73054;